export const channelDefaultRecipientSelector = (state) =>
  state.channel.defaultRecipient;
